import Vue from 'vue'
import domUtils from 'util/dom-utils'
import Popover from 'objects/popover/popover'

interface LoaderData {
  label?: string
  message: string
  type?: 'success' | 'error'
  autoClose?: boolean
}

const POPOVER_CONTAINER_ID = 'tt-standalone-popover'

/**
 * This is intended to be used for when a user first comes to the page.  If the popover shows
 * at a later time, then should be shown as part of the widget it applies to instead of as a
 * standalone.
 */
export default {
  // If it does not already exist, this creates a div as a descendant of body with
  // an id used for a standalone popover message. It then mounts the popover component
  // if not already mounted.
  load(data: LoaderData) {
    return new Promise((resolve) => {
      domUtils.appendDivToBody(POPOVER_CONTAINER_ID)
      new Vue({
        el: `#${POPOVER_CONTAINER_ID}`,
        data() { return { showPopover: true } },
        render(h) {
          if (this.showPopover) {
            return h(Popover, {
              attrs: { id: POPOVER_CONTAINER_ID },
              on: {
                close: () => {
                  this.showPopover = false
                  domUtils.removeFromBody(POPOVER_CONTAINER_ID)
                }
              },
              props: {
                ariaLabel: data.label || '',
                message: data.message,
                type: data.type || 'success',
                autoClose: data.autoClose || false
              },
              style: {
                top: '25%'
              }
            })
          }
        }
      })
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/standalone-popover/standalone-popover-loader.ts